import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import ConfirmDangerousActionForm from "@pathwright/ux/src/components/form/ConfirmDangerousActionForm"
import { useHomeRegistrationsLazyQuery } from "@pathwright/graphql-client/src/generated"
import { useTranslatedResourceTypeLabel } from "@pathwright/features/src/modules/resource/utils"
import { useHomeRegistrationVars } from "@pathwright/features/src/modules/unified-home/registration/HomeRegistrationQueryVars"
import { ConnectStores } from "lib/core/store"
import { useState } from "react"

const ResourceArchiveCard = ({
  card,
  resource,
  deleteResource,
  preventModalClose,
  toContinue,
  continueLabel,
  t
}) => {
  const [deleted, setDeleted] = useState(false)
  const [resourceName, setResourceName] = useState(null)
  const resourceTypeLabel = useTranslatedResourceTypeLabel(resource)
  const [refetchHomeRegistrations] = useHomeRegistrationsLazyQuery({
    variables: useHomeRegistrationVars(),
    fetchPolicy: "network-only"
  })

  const handleArchive = () => {
    const resourceName = resource.name
    const resourceId = resource != null ? resource.id : undefined
    preventModalClose()
    return deleteResource(resourceId).promise.then(() => {
      // library
      window.apolloClientStoreBridge.refetchLibraryResources()
      // teach tab
      window.apolloClientStoreBridge.refetchTeachingResources()
      // design tab
      window.apolloClientStoreBridge.refetchResources({})
      // learn tab
      window.apolloClientStoreBridge.refetchRegistrations({})

      // new home screen registrations
      refetchHomeRegistrations()

      setDeleted(true)
      setResourceName(resourceName)
    })
  }

  return (
    <Card
      card={card}
      hideClose={deleted}
      noaction
      title={resource ? `Delete ${resource.name}` : ""}
      className="ResourceArchiveCard"
    >
      {resource ? (
        <ConfirmDangerousActionForm
          confirmValue={resource.name}
          tConfirmLabel={({ label }) =>
            t("resource.cards.archive.blank_slate.button", {
              // The tConfirmLabel expects `label` but the translation expects `path`.
              label: label,
              path: label
            })
          }
          onSubmit={handleArchive}
          onCancel={card.onClose}
        >
          {({ formAction }) => (
            <BlankSlate
              icons={null}
              icon="caution-triangle"
              heading={t("resource.cards.archive.blank_slate.heading", {
                path: resource.name,
                resourceType: resourceTypeLabel
              })}
              body={t("resource.cards.archive.blank_slate.body", {
                resourceType: resourceTypeLabel
              })}
              preActionContent={formAction}
              stack
            />
          )}
        </ConfirmDangerousActionForm>
      ) : deleted ? (
        <BlankSlate
          icons={null}
          heading={`"${resourceName}" has been deleted`}
          primaryAction={{
            children: continueLabel,
            to: toContinue
          }}
        />
      ) : null}
    </Card>
  )
}

ResourceArchiveCard.displayName = "ResourceArchiveCard"

const mapStateToProps = function (state, ownProps) {
  const { resource } = state.resourceAdminStore.state
  const { deleteResource } = state.resourceAdminStore.action
  const { getHomeLocation } = state.navigationStore.request
  const { preventModalClose } = state.navigationStore.action
  const { modal_launched_from_url } = state.navigationStore.state

  let displayType = "course"
  if (resource && resource.resource_type === 30) displayType = "collection"
  if (resource && resource.resource_type === 20) displayType = "lesson"

  const shouldNavigateHome = window.location.pathname.startsWith("/library/")

  const toContinue = shouldNavigateHome
    ? getHomeLocation()
    : modal_launched_from_url
  const continueLabel = shouldNavigateHome ? "Continue to Home" : "Close"

  return _.assign(
    {},
    {
      resource,
      displayType,
      deleteResource,
      toContinue,
      continueLabel,
      preventModalClose
    },
    ownProps
  )
}

const connectStores = [
  { store: "navigation", watch: false },
  {
    store: "resourceAdmin",
    watch: ["resource"]
  },
  {
    store: "school",
    watch: false
  }
]

export default withTranslate(
  ConnectStores(ResourceArchiveCard, connectStores, {}, mapStateToProps)
)
